import { render, staticRenderFns } from "./RoadMap.vue?vue&type=template&id=bc88d20e&scoped=true"
import script from "./RoadMap.vue?vue&type=script&lang=js"
export * from "./RoadMap.vue?vue&type=script&lang=js"
import style0 from "./RoadMap.vue?vue&type=style&index=0&id=bc88d20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc88d20e",
  null
  
)

export default component.exports